/**
 * Leaving the page on purpose -- a redirect to Microsoft's sign-in, carrying
 * the open document across -- must not trip the "unsaved changes" prompt.
 */

let allowed = false

export function allowLeaving(): void {
  allowed = true
}

export function leavingAllowed(): boolean {
  return allowed
}
